import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IAnalytics, IDateRange } from '../models/models'

export class TrafficSourcesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/AnalyticsReporting/trafficSources',
      requesterInfo,
    })
  }

  public async trafficSources(request: IDateRange): Promise<IAnalytics[]> {
    return await this.postAsync<IAnalytics[]>(request)
  }
}
